module.exports = __webpack_public_path__ + "img/monitor4.f648a477.jpg";